import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Gates a route on a live operator session. Used by AdminLayout and by the
 * logistics kiosk, which sits outside the admin layout but reads the same
 * operator-only endpoints.
 */
export function RequireOperator({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === 'loading') {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--admin-bg, #1A0E08)',
          color: 'var(--admin-text, #E8E2D5)',
          fontSize: 13,
          opacity: 0.7,
        }}
      >
        Wczytywanie…
      </div>
    );
  }

  if (auth.status === 'unauthenticated') {
    return (
      <Navigate to="/admin/login" replace state={{ from: location.pathname + location.search }} />
    );
  }

  return <>{children}</>;
}
